import { cancelled, put, select, spawn, takeLatest } from 'redux-saga/effects';

import API, { rangeToAPI } from '@sm/api';
import { axiosCall, getCancelToken } from '@utils';
import { setNotificationMsgAction } from 'seller/store/actions';
import { selectorSelector } from 'seller/store/reducers';
import {
  PULL_SQP,
  PULL_SQP_STATUS,
  setMissedKeywordsAction,
  setSqpAction,
  setSqpLoadingAction,
  setSqpStatusAction
} from './index';

const pullSqpForDateRange = async (cancelToken, marketplaceID, dateRange, timeGrain) => {
  if (!dateRange) return [];
  const params = { marketplaceID, ...rangeToAPI(dateRange), group_by: timeGrain };
  const { data } = await axiosCall.get(API.sqp.products, { params, cancelToken });
  data.forEach(item => {
    // eslint-disable-next-line no-param-reassign
    if (!item.marketplace) item.marketplace = marketplaceID;
    // eslint-disable-next-line no-param-reassign
    if (!item.name) item.name = 'Unknown product';
  });
  return data;
};

function* pullMissedKeywordsSaga(params) {
  try {
    yield put(setMissedKeywordsAction([]));
    const { data: missedKeywords } = yield axiosCall.get(API.sqp.missed_keywords, { params });
    yield put(setMissedKeywordsAction(missedKeywords));
  } catch (error) {
    // yield put(
    //   setNotificationMsgAction(
    //     'Pull missed keywords failed. Please contact support@sellermetrix.com if problem persists.'
    //   )
    // );
  }
}

function* pullSqpSaga({ payload }) {
  const { cancelToken, cancelRequest } = getCancelToken();
  const { timeGrain } = payload;
  try {
    yield put(setSqpLoadingAction(true));
    const { dateRange, compareDateRange, marketplaceID } = yield select(selectorSelector);
    const [mainSqpList, compareSqpList] = yield Promise.all([
      pullSqpForDateRange(cancelToken, marketplaceID, dateRange, timeGrain),
      pullSqpForDateRange(cancelToken, marketplaceID, compareDateRange, timeGrain)
    ]);
    yield put(setSqpAction({ mainSqpList, compareSqpList }));
    yield spawn(pullMissedKeywordsSaga, {
      marketplaceID,
      ...rangeToAPI(dateRange),
      group_by: timeGrain
    });
  } catch (error) {
    yield put(setSqpAction({ mainSqpList: [], compareSqpList: [] }));
    yield put(
      setNotificationMsgAction(
        'Pull data failed. Please contact support@sellermetrix.com if problem persists.'
      )
    );
  } finally {
    if (yield cancelled()) cancelRequest();
    yield put(setSqpLoadingAction(false));
  }
}

function* pullSqpStatusSaga() {
  try {
    const { data: status } = yield axiosCall.get(API.sqp.status);
    yield put(setSqpStatusAction(status));
  } catch (error) {
    yield put(
      setNotificationMsgAction(
        'Pull data failed. Please contact support@sellermetrix.com if problem persists.'
      )
    );
  }
}

export function* amazonTrafficSagaWatcher() {
  yield takeLatest(PULL_SQP, pullSqpSaga);
  yield takeLatest(PULL_SQP_STATUS, pullSqpStatusSaga);
}
